<template>
  <sui-modal class="terminal-modal" size="large" :loading="true" v-model="visible" :closable="false" :closeIcon="true">
    <Terminal :entity="entity" v-if="visible && entity" @termEnd="close()" />
  </sui-modal>
</template>

<script>
  import Terminal from '@/components/Terminal'

  export default {
    name: 'ModalTerminal',
    components: {
      Terminal,
    },
    data() {
      return {
        visible: false,
        unescapable: true,
        entity: null,
      }
    },
    methods: {
      open(entity) {
        this.visible = true
        this.entity = entity
      },
      close() {
        this.visible = false
      },
    },
    created() {
      this.$modals.terminal = this
    },
  }
</script>

<style>
  .terminal-modal .modal  {
    width: 990px!important;
    height: 680px!important;
    background-color: #000!important;
  }
</style>
